import * as types from '../actions/types';

const initialState = {
    filter_key: "",
    success: false
}

export default function BannerFIlterDataReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.BANNER_FILTER_DATA:
            return {
                ...state,
                filter_key: action.payload,
                success: true
            }
        default:
            return state
    }
}